import React from 'react'
import PropTypes from 'prop-types'

import CategoryBox from './CategoryBox'

function CategoriesTab({ competitionSlug, categories }) {
  return (
    <div>
      {categories.map((category) => {
        return (
          <CategoryBox
            key={category.slug}
            category={category}
            imgPath={require(`images/competitions/digital_art/categories/${competitionSlug}_${category.slug}.jpg`)}
            sponsorImgPath={category.sponsor ? require(`images/competitions/digital_art/categories/sponsors/${category.sponsor.slug}.png`) : ''}
          />
        )
      })}
    </div>
  )
}

CategoriesTab.propTypes = {
  competitionSlug: PropTypes.string.isRequired,
  categories: PropTypes.array.isRequired,
}

export default CategoriesTab
